module.exports = __webpack_public_path__ + "static/img/lx.e334e5c7.png";